import { Prisma } from '@repo/database/src/types';

export interface SortDto {
  field: string;
  order: Prisma.SortOrder;
}
